import { render, staticRenderFns } from "./AutomationListEmpty.vue?vue&type=template&id=4ffa23b8&scoped=true&"
import script from "./AutomationListEmpty.vue?vue&type=script&lang=js&"
export * from "./AutomationListEmpty.vue?vue&type=script&lang=js&"
import style0 from "./AutomationListEmpty.vue?vue&type=style&index=0&id=4ffa23b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ffa23b8",
  null
  
)

export default component.exports